// eslint-disable-next-line import/prefer-default-export
export const MUNICIPALITY_LIST = '/:clientToken/municipalities';
